/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedModelPublisherDTO,
  PatchDocument,
  PublisherDTO,
} from '../models/index';
import {
    PagedModelPublisherDTOFromJSON,
    PagedModelPublisherDTOToJSON,
    PatchDocumentFromJSON,
    PatchDocumentToJSON,
    PublisherDTOFromJSON,
    PublisherDTOToJSON,
} from '../models/index';

export interface CreatePublisherRequest {
    publisherDTO: PublisherDTO;
}

export interface DeletePublisherRequest {
    publisherId: number;
}

export interface GetPublisherRequest {
    publisherId: number;
}

export interface GetPublishersRequest {
    page?: number;
    size?: number;
}

export interface UpdatePublisherRequest {
    publisherId: number;
    patchDocument: Array<PatchDocument>;
}

/**
 * 
 */
export class PublisherApi extends runtime.BaseAPI {

    /**
     * Creates request options for createPublisher without sending the request
     */
    async createPublisherRequestOpts(requestParameters: CreatePublisherRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['publisherDTO'] == null) {
            throw new runtime.RequiredError(
                'publisherDTO',
                'Required parameter "publisherDTO" was null or undefined when calling createPublisher().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publisher`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublisherDTOToJSON(requestParameters['publisherDTO']),
        };
    }

    /**
     */
    async createPublisherRaw(requestParameters: CreatePublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublisherDTO>> {
        const requestOptions = await this.createPublisherRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublisherDTOFromJSON(jsonValue));
    }

    /**
     */
    async createPublisher(requestParameters: CreatePublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublisherDTO> {
        const response = await this.createPublisherRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deletePublisher without sending the request
     */
    async deletePublisherRequestOpts(requestParameters: DeletePublisherRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['publisherId'] == null) {
            throw new runtime.RequiredError(
                'publisherId',
                'Required parameter "publisherId" was null or undefined when calling deletePublisher().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publisher/{publisherId}`;
        urlPath = urlPath.replace(`{${"publisherId"}}`, encodeURIComponent(String(requestParameters['publisherId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deletePublisherRaw(requestParameters: DeletePublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deletePublisherRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePublisher(requestParameters: DeletePublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePublisherRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getPublisher without sending the request
     */
    async getPublisherRequestOpts(requestParameters: GetPublisherRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['publisherId'] == null) {
            throw new runtime.RequiredError(
                'publisherId',
                'Required parameter "publisherId" was null or undefined when calling getPublisher().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publisher/{publisherId}`;
        urlPath = urlPath.replace(`{${"publisherId"}}`, encodeURIComponent(String(requestParameters['publisherId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPublisherRaw(requestParameters: GetPublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublisherDTO>> {
        const requestOptions = await this.getPublisherRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublisherDTOFromJSON(jsonValue));
    }

    /**
     */
    async getPublisher(requestParameters: GetPublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublisherDTO> {
        const response = await this.getPublisherRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPublishers without sending the request
     */
    async getPublishersRequestOpts(requestParameters: GetPublishersRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publisher`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPublishersRaw(requestParameters: GetPublishersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelPublisherDTO>> {
        const requestOptions = await this.getPublishersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelPublisherDTOFromJSON(jsonValue));
    }

    /**
     */
    async getPublishers(requestParameters: GetPublishersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelPublisherDTO> {
        const response = await this.getPublishersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePublisher without sending the request
     */
    async updatePublisherRequestOpts(requestParameters: UpdatePublisherRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['publisherId'] == null) {
            throw new runtime.RequiredError(
                'publisherId',
                'Required parameter "publisherId" was null or undefined when calling updatePublisher().'
            );
        }

        if (requestParameters['patchDocument'] == null) {
            throw new runtime.RequiredError(
                'patchDocument',
                'Required parameter "patchDocument" was null or undefined when calling updatePublisher().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publisher/{publisherId}`;
        urlPath = urlPath.replace(`{${"publisherId"}}`, encodeURIComponent(String(requestParameters['publisherId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['patchDocument']!.map(PatchDocumentToJSON),
        };
    }

    /**
     */
    async updatePublisherRaw(requestParameters: UpdatePublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublisherDTO>> {
        const requestOptions = await this.updatePublisherRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublisherDTOFromJSON(jsonValue));
    }

    /**
     */
    async updatePublisher(requestParameters: UpdatePublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublisherDTO> {
        const response = await this.updatePublisherRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
